export default __webpack_public_path__ + "static/media/suitenupcias_7.a9bf0008.jpg";